module.exports = __webpack_public_path__ + "media/images/category/feature/coj_d/logo-coj-zh-hant-a3da6bcdf9365c97e309110f1cbfb509.svg";